<template>
  <div class="home">
    <Nav />
    <div class="banner-img">
      <img src="../assets/02.png" />
    </div>
    <div class="main">
      <div class="pro-info">
        <div>
          <h3>产品描述</h3>
          <div class="mt25">基于ERP和税务数据，对客户评级打分，依据评级分值、行业、收入、客户规模等指标核定贷款。</div>
        </div>
        <div>
          <h3>申贷条件</h3>
          <div class="mt25">公司注册满1年、公司经营无异常、近一年开票收入大于50万。</div>
          <div>ERP帐套使用满1年。</div>
          <div>申请人征信当前无逾期。</div>
        </div>
        <div>
          <h3>申贷流程</h3>
          <img class="mt25" src="../assets/Bitmap.png">
        </div>
        <div>
          <h3>所需材料</h3>
          <div class="mt25">申贷基本资料，包括：法人基本信息、法人身份证照片、公司基本信息、联系人信息等。</div>
          <div>数据授权：金蝶KIS数据、税采数据、简版人行征信报告。</div>
          <div>网银银行流水（选填）。</div>
        </div>
        <div>
          <h3>贷款费用</h3>
          <div class="mt25">月息0.85%，年化10.2%。</div>
        </div>
        <div>
          <h3>还款方式</h3>
          <div class="mt25">还款方式为等本等息，计息方式为按月计息0.85%，年化10.2%。</div>
        </div>
        <div>
          <h3>逾期处理方式</h3>
          <div class="mt25">每日收取贷款本金的1.5‰罚息。</div>
        </div>
        <div>
          <h3>业务投诉电话</h3>
          <div class="mt25">4008-830-822</div>
        </div>
      </div>
      <Foot class="mt100"/>
    </div>
  </div>
</template>

<script>
import Nav from './Nav';
import Foot from './Foot';

export default {
  name: 'Home',
  components: { Nav, Foot },
  props: {
  },
  methods: {
    effectiveLoanEvent() {
      this.$router.push({ path: `/permission/index?${+new Date()}` });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  .home{
    .banner-img{
      img{
        width: 100%;
      }
    }
    .main{
      height:729px;
      padding-bottom: 100px;
      .pro-info{
        position: relative;
        margin-left: 25%;
        .black-bl{
          position: absolute;
          top: -17px;
          color: rgba(51,47,43,1);
          font-weight: 500;
          font-size: 26px;
        }
        div{
          font-size:13px;
          font-family:PingFangSC-Regular;
          font-weight:400;
          color:rgba(142,142,142,1);
          line-height:26px;
        }
        .mt25{
          margin-top: 25px;
        }
        h3{
          padding-top: 70px;
          font-size:20px;
          color:rgba(51,47,43,1);
        }
        .mt40{
          margin-top: 40px;
        }
        .ml60{
          margin-left: 3.125%;
        }
      }
    }

  }

</style>
